'use client';

import { useIsFetching } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

import { EntityRubric } from '@/shared/api/__generated__/models';
import { InViewport } from '../InViewport';
import { RubricCard } from '../RubricCard';

interface CategoryBlocksProps {
  rubrics: EntityRubric[];
}

export const CategoryBlocks = ({ rubrics }: CategoryBlocksProps) => {
  const [loaded, setLoaded] = useState(10);

  const increaseLoaded = useCallback(() => setLoaded((prev) => prev + 2), []);

  const isInfinityArticlesFetching = useIsFetching({
    queryKey: ['block-articles'],
  });
  const isMainArticlesFetching = useIsFetching({
    queryKey: ['main-block'],
  });

  const sortedRubrics = [...rubrics].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));

  return (
    <>
      {sortedRubrics.slice(0, loaded).map((rubric) => (
        <RubricCard slug={rubric.slug ?? ''} key={rubric.slug} />
      ))}

      <InViewport
        onInViewport={increaseLoaded}
        isActive={!isInfinityArticlesFetching && !isMainArticlesFetching}
      />
    </>
  );
};
